const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);
export const CONFIG = {
    IS_A1: false, VERSION: "1.2",


    API_URL: isLocalhost ? "https://apiv2.bercman.com/api/v1/" : "https://apiv2.bercman.com/api/v1/",
};


